import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select, { components } from "react-select";
import Layout from "../../layout";
import { Col, Form, Row } from "react-bootstrap";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import Services from "../../API/services";
import moment from "moment";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import ReactDatePicker from "react-datepicker";
import ReactGA from "react-ga4";
import { mainUrl } from "API/client/api";
import { toast } from "react-toastify";

const BookingReport = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    formState: { errors },
  } = useForm();

  const [booking, setBookings] = useState([]);
  const [filterBooking, setFilterBooking] = useState([]);
  const { userDetail } = useSelector(authenticationSeletor);
  const [fromdate, setFromDate] = useState(new Date());
  const [todate, setToDate] = useState(new Date());
  const [onOpenPicker, setOnOpenPicker] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(0);
  const [sourceStatus, setSourceStatus] = useState(0);
  const [dateFilterType, setDateFilterType] = useState("fromDate");
  const [selectedStatus, setSelectedStatus] = useState(0)
  const [fadeKey, setFadeKey] = useState(0);
  const { zone, state, hub, city, selectProperty, bookingId } = watch();
  const { access_token } = useSelector((state) => state.authentication)
  const [pageCount, setPageCount] = useState(0);
  const [exportFilter, setExportFilter] = useState({
    startDate: new Date(),
    endDate: new Date(),
    source: null,
    bookingStatus: null,
  });
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [zones, setZones] = useState([])
  const [states, setStates] = useState([])
  const [hubs, setHubs] = useState([])
  const [cities, setCities] = useState([])
  const [allProperty, setAllProperty] = useState([])
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [selectStatus, setSelectStatus] = useState([])

  useEffect(() => {
    setSelectedProperty([]);
    setValue("property", null);
  }, [selectedStatus])

  const fetchZones = async () => {
    try {
      const res = await Services.property.allZoneService()
      if (res.data.status === true) {
        setZones(res.data.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    fetchZones()
  }, [])

  const fetchStateByZone = async () => {
    try {
      const res = await Services.property.getStateByZone(zone)
      if (res.data.status === true) {
        setStates(res.data.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    if (zone) {
      fetchStateByZone(zone)
    }
  }, [zone])

  const fetchHubByState = async () => {
    try {
      const res = await Services.property.getHubByState(state)
      if (res.data.status === true) {
        setHubs(res.data.data.Hubs)
      }
    }
    catch { }
  }

  useEffect(() => {
    if (state) {
      fetchHubByState(state)
    }
  }, [state])

  const fetchCityByHub = async () => {
    try {
      const res = await Services.property.getCityByHub(hub)
      if (res.data.status === true) {
        setCities(res.data.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    if (state) {
      fetchCityByHub(hub)
    }
  }, [hub])

  const fetchProperties = async () => {
    try {
      let zoneName = zones?.find((item) => item?.id == zone)?.name;
      let params = new URLSearchParams();
      params.append("countryId", "IN");
      if (zoneName) params.append("zone", zoneName);
      if (state) params.append("stateId", state);
      if (hub) params.append("hub", hub);
      if (city) params.append("cityId", city);
      const res = await Services.property.getPropertyByArea(`?${params.toString()}`);
      if (res.data.status === true) {
        setAllProperty(res?.data?.data);
      }
    } catch {
      // Handle error if needed
    }
  };

  useEffect(() => {
    fetchProperties();
  }, [city, zones, state, hub]);

  const getData = async () => {
    try {
      const query = `page=${page}&size=${limit}`;
      const res = await Services.globalService.getBookingPropertyIdService(
        userDetail?.propertyId,
        query
      );
      if (res.status === 200) {
        setPageCount(
          res.data.totalItems > limit
            ? Math.round(res.data.totalItems / limit) + 1
            : 0
        );
        setBookings(res.data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "booking_reporting" });
    if (userDetail?.logintype != "rroomUser") getData();
  }, [userDetail, page, limit]);

  const tableRef = useRef();
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "bookingDetails",
    sheet: "bookingDetails",
  });

  useEffect(() => {
    setFilterBooking(booking);
  }, [booking]);

  const [filterDate, setFilterDate] = useState(new Date());
  const dateFilter = () => {
    const resultsData = booking.filter((order) => {
      return (
        new Date(order?.createdAt).toJSON().slice(0, 25) >=
        new Date(filterDate).toJSON().slice(0, 25)
      );
    });
    setFilterBooking(resultsData);
  };


  const submitFilter = async () => {
    let status;
    let source;
    let property;
    if (selectedStatus != 6 && selectedStatus != 7) {
      if (userDetail?.logintype == "rroomUser") {
        if (selectStatus.length > 0) {
          status = `&bookingStatus=${selectStatus?.map((item) => item.id).toString()}`
        }
        else {
          status = "";
        }
        if (selectedProperty.length > 0) {
          property = `&propertyId=${selectedProperty?.map((item) => item.id).toString()}`
        }
        else {
          property = "";
        }
        source = sourceStatus != "0" ? `&source=${sourceStatus}` : "";
      }
      else if (userDetail?.logintype == "propertyUser") {
        status = selectedStatus == 0 ? selectStatus.length > 0 ? `&bookingStatus=${selectStatus?.map((item) => item.id).toString()}` : '' : `&bookingStatus=${selectedStatus}`;
        source = sourceStatus != "0" ? `&source=${sourceStatus}` : "";
        property = `&propertyId=${userDetail?.propertyId}`
      }
      const filterState = `fromDate=${moment(fromdate).format("YYYY-MM-DD")}&toDate=${moment(todate).format("YYYY-MM-DD")}${status}${source}${property}&userType=${userDetail?.logintype == "rroomUser" ? 'rroomUser' : 'propertyUser'}&dateType=${selectedStatus == 2 ? 'toDate' : 'fromDate'}`;
      const response = await fetch(`${mainUrl}api/kpi/booking-report?${filterState}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${access_token}`
        }
      });
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Booking-Report-${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
    else if (selectedStatus == 7) {
      const res = await fetch(`${mainUrl}api/booking/booking-audit-pdf?propertyId=${selectedProperty?.id || userDetail?.propertyId}&fromDate=${moment(fromdate).format("YYYY-MM-DD")}&toDate=${moment(todate).format("YYYY-MM-DD")}${bookingId ? `&bookingCode=${bookingId}` : ''}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${access_token}`
        }
      });
      if (res.ok == true) {
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Audit-Trail-Report-${moment().format("YYYY-MM-DD")}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      else {
        toast.warn("Invalid Booking Code. Please try again!");
      }
    }
    else {
      let propertys = userDetail?.logintype == "propertyUser" ? `&propertyId=${userDetail?.propertyId}&userType=propertyUser` : ''
      const res = await fetch(`${mainUrl}api/booking/booking-payment-report?fromdate=${moment(fromdate).format("YYYY-MM-DD")}&todate=${moment(todate).format("YYYY-MM-DD")}${propertys}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${access_token}`
        }
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Booking-Payment-Report-${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };

  useEffect(() => {
    dateFilter();
  }, [filterDate]);

  const allTabs = [
    { id: 0, name: "Booking Report" },
    { id: 1, name: "Guest Arrival Report" },
    { id: 2, name: "Guest Departure Report" },
    { id: 4, name: "Booking Cancellation Report" },
    { id: 5, name: "No Show Report" },
    { id: 6, name: "Payment Report" },
    { id: 7, name: "Audit Trail" }
  ]

  useEffect(() => {
    setFadeKey((prev) => prev + 1);
  }, [selectedStatus]);

  const selectStatusHandler = (status) => {
    setSelectedStatus(status)
  }

  const bStatus = [
    { id: 0, name: "Pending" },
    { id: 1, name: "Upcoming" },
    { id: 2, name: "In-House" },
    { id: 3, name: "Checked-Out" },
    { id: 4, name: "Cancelled" },
    { id: 5, name: "No-Show" },
  ]

  // const CheckboxOption = (props) => {
  //   return (
  //     <components.Option {...props}>
  //       <input
  //         type="checkbox"
  //         checked={props.isSelected}
  //         onChange={() => null}
  //         style={{ marginRight: 8, display: 'none' }}
  //       />
  //       <label>{props.label}</label>
  //     </components.Option>
  //   );
  // };

  const options = [
    // { id: "0", name: "All" },
    { id: "RRooms", name: "RRooms" },
    { id: "Walk-In", name: "Walk In" },
    { id: "OTA", name: "OTA" },
    { id: "TA", name: "TA" },
  ];

  const handleChange = (selected) => {
    let finalSelection = selected;
    if (selected.some((s) => s.id == "0")) {
      finalSelection = options.filter((o) => o.id !== "0");
    }
    const names = finalSelection.map((s) => s.id).join(",");
    setSourceStatus(names);
  };

  return (
    <Layout title="Booking Report">
      {
        <div className="tab-primary border-bottom">
          <ul className="d-flex align-items-center mb-0">
            {
              allTabs
                ?.filter((item, ind) => {
                  let newIndex = ind + 1
                  if (userDetail?.logintype == "rroomUser") {
                    return newIndex === 1 || newIndex === 7;
                  }
                  return true
                }).map((item) => {
                  return (
                    <li
                      key={item?.id}
                      className={item?.id == selectedStatus ? 'active' : ''}
                      onClick={() => selectStatusHandler(item?.id)}>
                      {item?.name}
                    </li>
                  )
                })
            }
          </ul>
        </div>
      }
      <div className="flex justify-content-center align-items-center report-page">
        <div className={userDetail?.logintype == "propertyUser" ? "col-lg-10 dflex justify-content-center p-0" : "flex col-lg-10 d-flex justify-content-center p-0"}>
          <Form className="bg-white rounded-2 report-form" onSubmit={handleSubmit(submitFilter)}>
            <Row key={fadeKey} className="addBookingRow fade-in-box">
              {
                userDetail.logintype == "rroomUser" &&
                <div className="">
                  <div className='row flex'>
                    <div className='col-lg-3'>
                      <div className="form-group">
                        <label className="text-black">Select Zone</label>
                        <select
                          className="form-control"
                          {...register("zone")}
                        >
                          <option value="">Select Zone</option>
                          {zones?.map((item) => (
                            <option key={item.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-3'>
                      <div className="form-group">
                        <label className="text-black">Select State</label>
                        <select
                          className="form-control"
                          {...register("state")}
                        >
                          <option value="">Select State</option>
                          {states?.map((item) => (
                            <option key={item.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-3'>
                      <div className="form-group">
                        <label className="text-black">Select Hub</label>
                        <select
                          className="form-control"
                          {...register("hub")}
                        >
                          <option value="">Select Hub</option>
                          {hubs?.map((item) => (
                            <option key={item.id} value={item?.id}>
                              {item?.hubname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-3'>
                      <div className="form-group">
                        <label className="text-black">Select City</label>
                        <select
                          className="form-control"
                          {...register("city")}
                        >
                          <option value="">Select City</option>
                          {cities?.map((item) => (
                            <option key={item.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className='col-lg-12'>
                      <div className="form-group">
                        <label className="text-black">
                          Select Property
                          {(userDetail.logintype == "rroomUser" && selectedStatus == 7) ? <span className="text-danger">*</span> : ''}
                        </label>
                        <Controller
                          name="property"
                          control={control}
                          rules={{ required: (userDetail.logintype == "rroomUser" && selectedStatus == 7) ? "Please select a property" : false }}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              <Select
                                {...field}
                                options={allProperty}
                                placeholder="Select a Property"
                                isSearchable
                                getOptionLabel={(e) => `${e.propertyCode} - ${e.name}`}
                                getOptionValue={(e) => e.id}
                                isMulti={selectedStatus != "7"}
                                onChange={(value) => {
                                  field.onChange(value);
                                  setSelectedProperty(value);
                                }}
                                value={field.value}
                                closeMenuOnSelect={false}
                              />
                            </>
                          )}
                        />

                        {errors.property && <p className="text-danger fs-8">{errors.property.message}</p>}
                      </div>
                    </div>
                  </div>
                </div>
              }
              {
                ((selectedStatus == "0" && userDetail?.logintype == "propertyUser") || (selectedStatus == "0" && userDetail?.logintype == "rroomUser")) &&
                <div className='col-lg-4'>
                  <div className="form-group">
                    <label className="text-black">Select Status</label>
                    <Select
                      options={bStatus}
                      placeholder="All"
                      isSearchable
                      getOptionLabel={(e) => `${e.name}`}
                      getOptionValue={(e) => e.id}
                      value={selectStatus}
                      onChange={(value) => setSelectStatus(value)}
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </div>
                </div>
              }
              {
                (selectedStatus == "7") &&
                <div className='col-lg-4'>
                  <div className="form-group">
                    <label className="text-black">Booking Code</label>
                    <input
                      type="text"
                      className="field-control"
                      placeholder="Booking Code"
                      {...register("bookingId")}
                    />
                  </div>
                </div>
              }
              <Col lg={userDetail.logintype == "propertyUser" ? 4 : 4} className="form-group gap-2 d-flex flex-column">
                <label className="text-black m-0 fs-6">Date Range</label>
                <ReactDatePicker
                  selectsRange={true}
                  startDate={fromdate}
                  endDate={todate}
                  onChange={(dates) => {
                    const [start, end] = dates;
                    setFromDate(start);
                    setToDate(end);
                  }}
                  className="field-control"
                  dateFormat="yyyy/MM/dd"
                  placeholderText="Select date range"
                />
              </Col>
              {/* {(userDetail.logintype == "propertyUser" && selectedStatus != 6 && selectedStatus != 7) ?
                <Col lg={4} className="form-group gap-2 d-flex flex-column">
                  <label className="text-black m-0 fs-6">Source </label>
                  <select
                    onChange={(e) => setSourceStatus(e.target.value)}
                    className="field-control form-select"
                  >
                    <option value="0" selected>
                      All
                    </option>
                    <option value="RRooms">RRooms</option>
                    <option value="Walk-In">Walk In</option>
                    <option value="OTA">OTA</option>
                    <option value="TA">TA</option>
                  </select>
                </Col>
                : ''} */}
              {(selectedStatus != 6 && selectedStatus != 7) ?
                <Col lg={4} className="form-group gap-2 d-flex flex-column">
                  <label className="text-black m-0 fs-6">Source </label>
                  <Select
                    options={options}
                    placeholder="All"
                    isSearchable
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    onChange={handleChange}
                    isMulti
                    closeMenuOnSelect={false}
                  // value={sourceStatus}
                  />
                </Col>
                : ''}
              <Col lg={12} className="text-right pt-1">
                <button
                  type="submit"
                  className="btn btn-success rounded-5"
                >
                  Export {selectedStatus == "7" ? "Pdf" : "Excel"}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Layout>
  )
};

export default BookingReport;